var React = require('react');

function IconAzureColor (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"icomoon-ignore","key":0}),React.createElement("path",{"fill":"#0089d6","d":"M474.453 866.987l242.347-42.667h1.707l-124.587-148.48c-40.96-49.493-83.627-98.987-124.587-148.48 0 0 128-353.28 129.707-354.987 0 0 87.040 150.187 211.627 365.227l213.333 368.64 1.707 3.413h-788.48l237.227-42.667zM0 820.907c0 0 58.027-102.4 129.707-225.28l129.707-225.28 151.893-128c83.627-69.973 151.893-126.293 151.893-126.293 0 1.707 0 3.413-1.707 5.12l-163.84 353.28-162.133 346.453h-117.76c-64.853 0-117.76 0-117.76 0v0z","key":1})]);
}

IconAzureColor.defaultProps = {"version":"1.1","width":"1024","height":"1024","viewBox":"0 0 1024 1024"};

module.exports = IconAzureColor;

IconAzureColor.default = IconAzureColor;
